import { useState } from 'react'
import { generateImage } from '../services/api'
import { useChatStore } from '../stores/chatStore'

export default function ImageGen() {
  const [prompt, setPrompt] = useState('')
  const [image, setImage] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const showImageGen = useChatStore((s) => s.showImageGen)
  const setShowImageGen = useChatStore((s) => s.setShowImageGen)

  if (!showImageGen) return null

  const handleGenerate = async () => {
    if (!prompt.trim() || loading) return
    setLoading(true); setError(''); setImage(null)
    try {
      const url = await generateImage(prompt)
      if (url) setImage(url)
      else setError('Failed to generate. Check Venice.ai API key.')
    } catch { setError('Network error') }
    setLoading(false)
  }

  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-black/60">
      <div className="bg-gray-850 border border-gray-700 rounded-2xl w-full max-w-lg p-6 mx-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-white font-semibold">Generate Image</h2>
          <button onClick={() => setShowImageGen(false)} className="text-gray-400 hover:text-white text-xl">×</button>
        </div>
        <textarea value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder="Describe the image..." rows={3}
          className="w-full bg-gray-900 border border-gray-700 rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 resize-none focus:outline-none focus:border-gray-500 mb-3" />
        <button onClick={handleGenerate} disabled={loading || !prompt.trim()}
          className="w-full py-2 rounded-xl bg-white text-black font-medium text-sm disabled:opacity-40 hover:opacity-90">
          {loading ? 'Generating...' : 'Generate'}
        </button>
        {error && <p className="text-red-400 text-sm mt-2">{error}</p>}
        {image && <div className="mt-3 rounded-xl overflow-hidden border border-gray-700"><img src={image} alt="Generated" className="w-full" /></div>}
      </div>
    </div>
  )
}
